import { UserInteractiveService } from "@/Services/user-interactive.service";
import { ModalDevolverArchivoPasoAnteriorComponent } from "@/shared/components/botoneras/modal-devolver-archivo-paso-anterior/modal-devolver-archivo-paso-anterior.component";
import { inject, Injectable } from "@angular/core";
import { DynamicDialogConfig } from "primeng/dynamicdialog";
import { lastValueFrom } from "rxjs";
import { IAnularDocumento, IDatosAdicionales, IDevolverArchivos, IFirma, IFirmaCertificada, IOrdenPago, IPaso, IRetornarDocumento, ISaltarPaso, ISaltarPasoAdmin, ISaltarPasoRela, IVariables, IVerDocumentosRelacionados, IVerRubros } from "./botonera.interface";
import { IAccionBoton } from "@/interface/general/IPagination";
import { BotoneraApiService } from "./botonera.api.service";
import { FilePreviewComponent } from "../general/file-preview/file-preview.component";
import { TableOfItemComponent } from "../general/table-of-items/table-of-items.component";
import { ModalDocumentosRelacionadosComponent } from "@/shared/components/botoneras/modal-documentos-relacionados/modal-documentos-relacionados.component";
import { ModalAnularDocumentosComponent } from "./modal-anular-documentos/modal-anular-documentos.component";
import { ModalGenericComponent } from "../general/modal-generic/modal-generic.component";
import { EActionEventCrud } from "@/common/enums/general.enum";
import { TypeColumn } from "@/interface/general/ITable";
import { ModalRetornarDocumentoComponent } from "./modal-retornar-documento/modal-retornar-documento.component";
import { ModalVerMotivosComponent } from "./modal-ver-motivos/modal-ver-motivos.component";
import { BTN_ACCION } from "@/common/enums/btn_accion";
import { ModalHerramientasParaAdministradoresComponent } from "./modal-herramientas-para-administradores/modal-herramientas-para-administradores.component";
import { ModalSaltarPasoComponent } from "./modal-saltar-paso/modal-saltar-paso.component";
import { DataSignService } from "./modal-sign-generic/services/data.service";
import { ModalSignGenericComponent } from "./modal-sign-generic/modal-sign-generic.component";
import { ModalModificarPdfComponent } from "./modal-modificar-pdf/modal-modificar-pdf.component";
import { Router } from "@angular/router";
import { TypeMessage } from "@/common/enums/general/TypeMessage";
import { ModalFirmaCertificadaComponent } from "./modal-firma-certificada/modal-firma-certificadacomponent";
import { ModalDatosAdicionalesComponent } from "./modal-datos-adicionales/modal-datos-adicionales.component";
import { DocumentoEditarService } from "@/pages/radicacion/flujo-doc-procesos/service/documentoEditar.service";
import { ModalSaltarPasoAdminComponent } from "./modal-saltar-paso-admin/modal-saltar-paso-admin.component";
import { ModalTimelineDocumentoComponent } from "./modal-timeline-documento/modal-timeline-documento.component";

@Injectable({
  providedIn: 'root',
})
export class BotoneraService {
  private userInteractiveService = inject(UserInteractiveService);
  private apiService = inject(BotoneraApiService);
  private dataSignService = inject(DataSignService);
  private documentoEditarService = inject(DocumentoEditarService);
  private router = inject(Router);


  async handleAction(record: any, btn: IAccionBoton, event?: any): Promise<boolean> {
    switch (btn.Exec) {
      case BTN_ACCION.VER_PDF:
        await this.verDocumento(btn); // Cambio temporal para prueba con modificarPdf
        return false;
      case BTN_ACCION.MODIFICAR_PDF_ADMIN:
        await this.modificarPdf(btn);
        return false;
      case BTN_ACCION.VER_RUBROS:
        await this.verRubros(btn);
        return false;
      case BTN_ACCION.VER_DOCUMENTOS_RELACIONADOS:
        await this.verDocumentosRelacionados(btn);
        return false;
      case BTN_ACCION.VER_TIMELINE_DOCUMENTO:
        await this.verTimeLineDocumento(btn);
        return false;
      case BTN_ACCION.SIGUIENTE_PASO:
        return await this.SiguientePaso(btn);
      case BTN_ACCION.RETORNAR_DOCUMENTO:
        return await this.retornarDocumento(btn);
      case BTN_ACCION.DEVOLVER_DOCUMENTO:
        return await this.devolverDocumento(btn);
      case BTN_ACCION.CONTABILIZAR:
        return await this.procesoFirma(btn);
      case BTN_ACCION.ELABORO:
        return await this.procesoFirma(btn);
      case BTN_ACCION.REVIZO:
        return await this.procesoFirma(btn);
      case BTN_ACCION.FIRMAR:
        return await this.procesoFirma(btn);
      case BTN_ACCION.PAGAR:
        return await this.procesoFirma(btn);
      case BTN_ACCION.AUDITADO:
        return await this.procesoFirma(btn);
      case BTN_ACCION.CONFIRMAR_PAGO:
        return await this.procesoFirma(btn);
      case BTN_ACCION.VTO_BNO:
        return await this.procesoFirma(btn);
      case BTN_ACCION.ANULAR_DOCUMENTO:
        return await this.anularDocumento(btn);
      case BTN_ACCION.VER_TOOLS_ADMIN:
        await this.verToolsAdmin(btn);
        return false;
      case BTN_ACCION.SALTAR_PASO:
        return await this.saltarPaso(btn);
      case BTN_ACCION.SALTAR_PASO_ADMIN:
        return await this.saltarPasoAdmin(btn); 
      case BTN_ACCION.VER_MOTIVOS:
        await this.verMotivos(btn);
        return false;
      case BTN_ACCION.EDITARREGISTRO:
        this.editarRegistro(record, btn, event);
        return false;
      case BTN_ACCION.EDITARMODIFICARREGISTRO:
        this.editarModificarRegistro(record, btn, event);
        return false;
      case BTN_ACCION.FIRMA_CERTIFICADA:
        return await this.firmaCertificada(btn);
      case BTN_ACCION.NOTIFICAR_RESPUESTA:
        return await this.notificarRespuesta(btn);
      case BTN_ACCION.GENERAR_ORDEN_PAGO:
        return await this.generarOrdenPago(btn);
      case BTN_ACCION.DATOS_ADICIONALES:
        return await this.datosAdicionales(btn);
      default:
        console.warn('Acción desconocida:', btn.Exec);
        return false;
    }
  }

  async verDocumento(accion: IAccionBoton) {
    if (accion.FileType.toLowerCase().includes('base64')) {
      // Chequea que viene
      const fileBase64 = accion.Url1 
        ? (await lastValueFrom(this.apiService.getFile(accion.Url1 ?? ''))).fileBase64
        : accion.FileBase64;
      // Presenta el base64
      return this.previewFileBase64(accion.Data_Value,accion.FileType, fileBase64);
    } else {
        return this.previewFileBase64(accion.Data_Value,accion.FileType, accion.Url2 ?? '');
    }
  }

  async verRubros(btn: IAccionBoton) {
    const data: IVerRubros = {  
      IdfdArchivo: Number(btn.Data_Value),
      urlApi: 'FlujoDocRad/GetFlujoDocMultiCuentasContables',
      columns: [
        { field: 'IdMulti', label: 'IdMulti', type: TypeColumn.NUMBER },
        { field: 'IdPaquete', label: 'Paquete', type: TypeColumn.NUMBER },
        { field: 'tipo', label: 'Tipo', type: TypeColumn.STRING },
        { field: 'Ano', label: 'Año', type: TypeColumn.STRING },
      ],
    };

    const config: DynamicDialogConfig = { 
      header: 'Rubros, Sub-Rubros y Centros de Costos', 
      data,
    };

    const modalResponse = this.userInteractiveService.openDialog(TableOfItemComponent, config);

    return await lastValueFrom(modalResponse.onClose);
  }

  async verDocumentosRelacionados(btn: IAccionBoton) {
    const data: IVerDocumentosRelacionados = {
      IdfdArchivo: Number(btn.Data_Value),
      action: EActionEventCrud.NA,
      record: { IdfdArchivo: Number(btn.Data_Value) },
      showCompareButton: true,
      showseeButton: true,
    };

    const config: DynamicDialogConfig = { 
      header: `🌳 Documentos Relacionados, Documento Consultado: ${data.IdfdArchivo}`,
      data,
    };

    const modalResponse = this.userInteractiveService.openDialog(ModalDocumentosRelacionadosComponent, config);
    
    return await lastValueFrom(modalResponse.onClose);
  }

  async verTimeLineDocumento(btn: IAccionBoton) {
    const data: IVerDocumentosRelacionados = {
      IdfdArchivo: Number(btn.Data_Value),
      action: EActionEventCrud.NA,
      record: { IdfdArchivo: Number(btn.Data_Value) },
      showCompareButton: true,
      showseeButton: true,
    };

    const config: DynamicDialogConfig = {
      header: `🕘 Timeline del Documento, Documento Consultado: ${data.IdfdArchivo}`,
      data,

      width: '100vw',
      height: '100vh',

      maximizable: true,

      style: {
        'max-width': '100vw',
        'width': '100vw',
        'height': '100vh',
        'max-height': '100vh',
      },

      contentStyle: {
        overflow: 'auto',
      },
    };

    const modalResponse = this.userInteractiveService.openDialog(
      ModalTimelineDocumentoComponent,
      config
    );

    return await lastValueFrom(modalResponse.onClose);
  }

  async SiguientePaso(btn: IAccionBoton) {
    const data: IPaso = JSON.parse(btn.Data_Value);
    const result = await this._dialogConfirmacion('¿Desea enviar el documento al siguiente paso? Documento :'+data.IdfdArchivo);        
    if (result) {
      const data: IPaso = JSON.parse(btn.Data_Value);
      return await lastValueFrom(this.apiService.PutEnviarSiguientePaso(data));
    } else {
      return false;
    }
  }

  async retornarDocumento(btn: IAccionBoton) {
    const data: IRetornarDocumento = JSON.parse(btn.Data_Value);
    const config: DynamicDialogConfig = { header: 'Retornar Documento', width: '80%', data, templates: { footer: undefined } };
    const modalResponse = this.userInteractiveService.openDialog(ModalRetornarDocumentoComponent, config);
    return await lastValueFrom(modalResponse.onClose);
  }

  async devolverDocumento(btn: IAccionBoton): Promise<boolean> {
    const data: IDevolverArchivos = JSON.parse(btn.Data_Value);
    const config: DynamicDialogConfig = { header: btn.Mensaje, width: '80%', data, templates: { footer: undefined} };
    const modalResponse = this.userInteractiveService.openDialog(ModalDevolverArchivoPasoAnteriorComponent, config);
    return await lastValueFrom(modalResponse.onClose);
  }

  async procesoFirma(btn: IAccionBoton) {
    const registro: IFirma = JSON.parse(btn.Data_Value);
    const initialData = await lastValueFrom(this.dataSignService.getGetInitialDataSign(registro.tipoFirma, registro.CodGlobal2)); 
    const config: DynamicDialogConfig = { header: btn.Mensaje, data: { registro, initialData } };
    const modalResponse =  this.userInteractiveService.openDialog(ModalSignGenericComponent, config);
    return await lastValueFrom(modalResponse.onClose);
  }

  async anularDocumento(btn: IAccionBoton): Promise<boolean> {
    const data: IAnularDocumento = JSON.parse(btn.Data_Value);
    const config: DynamicDialogConfig = { header: 'Anular Documento :'+data.IdfdArchivo, width: '50%', data, templates: { footer: undefined } };
    const modalResponse = this.userInteractiveService.openDialog(ModalAnularDocumentosComponent, config);
    return await lastValueFrom(modalResponse.onClose);
  }

  async verToolsAdmin(btn: IAccionBoton): Promise<void> {       
    const IdfdArchivo =  Number(btn.Data_Value);
    const config: DynamicDialogConfig<IVariables> = { header: 'Herramientas para administradores', width: '80%', data: { IdfdArchivo } };
    const modalResponse = this.userInteractiveService.openDialog(ModalHerramientasParaAdministradoresComponent, config);
    return await lastValueFrom(modalResponse.onClose);
  }

  async saltarPaso(btn: IAccionBoton): Promise<boolean> {
    const data: ISaltarPaso = JSON.parse(btn.Data_Value);
    const config: DynamicDialogConfig = { header: 'Saltar paso - Documento: '+data.IdfdArchivo, width: '80%', data, templates: { footer: undefined} };
    const modalResponse = this.userInteractiveService.openDialog(ModalSaltarPasoComponent, config);
    return await lastValueFrom(modalResponse.onClose);
  }

  async saltarPasoAdmin(btn: IAccionBoton): Promise<boolean> {
    const data: ISaltarPasoAdmin = JSON.parse(btn.Data_Value);
    const config: DynamicDialogConfig = { header: 'Ingrese el Motivo y Eliga un Paso para Saltar paso - Documento: '+data.IdfdArchivo, width: '80%', data, templates: { footer: undefined} };
    const modalResponse = this.userInteractiveService.openDialog(ModalSaltarPasoAdminComponent, config);
    return await lastValueFrom(modalResponse.onClose);
  }

  async verMotivos(btn: IAccionBoton): Promise<void> {
    const IdfdArchivo =  Number(btn.Data_Value);
    const data = { IdfdArchivo:IdfdArchivo, CodRadicado:"0"}
    const config: DynamicDialogConfig = { header: 'Ver Motivos - Documento: '+IdfdArchivo, width: '80%', data: data };
    const modalResponse = this.userInteractiveService.openDialog(ModalVerMotivosComponent, config);
    return await lastValueFrom(modalResponse.onClose);
  }

   async verMotivosRadicado(CodRadicado : string): Promise<void> {
    const data = { IdfdArchivo:0, CodRadicado:CodRadicado }
    const config: DynamicDialogConfig = { header: 'Ver Motivos - Radicado: '+CodRadicado, width: '80%', data: data };
    const modalResponse = this.userInteractiveService.openDialog(ModalVerMotivosComponent, config);
    return await lastValueFrom(modalResponse.onClose);
  }

  async modificarPdf(btn: IAccionBoton): Promise<void> {
    const IdfdArchivo =  Number(btn.Data_Value);
    const config: DynamicDialogConfig = { header: 'Modificar PDF - Documento: '+IdfdArchivo, width: '80%', data: IdfdArchivo };
    const modalResponse = this.userInteractiveService.openDialog(ModalModificarPdfComponent, config);
    return await lastValueFrom(modalResponse.onClose);
  }

  editarRegistro(record: any, btn: IAccionBoton, event?: any) {
    const routetarget = ['/radicacion/flujo-doc-procesos/renderizar-tabs-dinamicamente'];
    const urlTree = this.router.createUrlTree(routetarget);
    const url = this.router.serializeUrl(urlTree);
    const mouseEvent = event as MouseEvent;
    // Almacena info necesario para el lugar donde redirecciona
    this._storeData(record, btn, event)
    // redireccion
    setTimeout(() => {
      if (mouseEvent.ctrlKey || mouseEvent.metaKey) {
        window.open(url, '_blank');
      } else {
        this.router.navigateByUrl(url);
      }
    }, 10);
  }

  editarModificarRegistro(record: any, btn: IAccionBoton, event?: any) {
    this.documentoEditarService.editarDocumento(
      record.IdfdArchivo
    );
  }

  async firmaCertificada(btn: IAccionBoton) {
    const data: IFirmaCertificada = JSON.parse(btn.Data_Value);
    const config: DynamicDialogConfig = { header: 'Firma electrónica - Documento: ' + (data.CodRadicado ?? data.IdfdArchivo), width: '500px', data, templates: { footer: undefined} };
    const modalResponse = this.userInteractiveService.openDialog(ModalFirmaCertificadaComponent, config);
    return await lastValueFrom(modalResponse.onClose);
  }

  previewFileBase64(codarchivo:any ,fileType: string, fileUrl: string) {
    const config: DynamicDialogConfig = {
        header: 'Visualizar Documento :'+codarchivo,
        data: { fileType, fileUrl, showDownloadButton: true },
    };

    return this.userInteractiveService.openDialog(FilePreviewComponent, config);
  }

  messageCautionForNoResults() {
    this.userInteractiveService.sendMessage(
      TypeMessage.WARNING, 
      'No se encontraron registros con los criterios seleccionados',
      undefined,
      'La información puede no estar disponible según el estado o las reglas de visualización. Si considera que existe una inconsistencia, contacte al administrador.'
    );
  }

  async notificarRespuesta(btn: IAccionBoton) {
    const data: IVariables = JSON.parse(btn.Data_Value);
    const result = await this._dialogConfirmacion('¿Desea enviar notificación vía correo electronico al usuario? Documento :'+data.IdfdArchivo);        
    if (result) {
      const data: IPaso = JSON.parse(btn.Data_Value);
      return await lastValueFrom(this.apiService.PostNotificarRespuesta(data));
    } else {
      return false;
    }
  }

  async generarOrdenPago(btn: IAccionBoton) {
    const IdfdArchivo =  Number(btn.Data_Value);
    const result = await this._dialogConfirmacion('¿Desea generar orden de pago para el documento? Documento :'+ IdfdArchivo);        
    if (result) {
      const data: IOrdenPago = { IdfdArchivo };
      return await lastValueFrom(this.apiService.PostGenerarOrdenPago(data));
    } else {
      return false;
    }
  }

  async datosAdicionales(btn: IAccionBoton) {
    const data: IDatosAdicionales = JSON.parse(btn.Data_Value);
    const config: DynamicDialogConfig = { header: 'Datos Adicionales para Documento: ' + (data.IdfdArchivo), width: '70%', data, templates: { footer: undefined} };
    const modalResponse = this.userInteractiveService.openDialog(ModalDatosAdicionalesComponent, config);
    return await lastValueFrom(modalResponse.onClose);
  }

  async SiguientePasoMasivo(data: IPaso) {
    return await lastValueFrom(this.apiService.PutEnviarSiguientePaso(data));
  }

  async SaltarPasoMasivo(data: ISaltarPaso): Promise<boolean> {
    const config: DynamicDialogConfig = { header: 'Saltar paso - Masivo', width: '80%', data, templates: { footer: undefined} };
    const modalResponse = this.userInteractiveService.openDialog(ModalSaltarPasoComponent, config);
    return await lastValueFrom(modalResponse.onClose);
  }

  private async _dialogConfirmacion (message: string) {
    const config: DynamicDialogConfig = { 
        header: `Confirmación`,
        width: '50%',
        data: {
            message: message,
            tipoConfirmacion: 'warning',
            confirmLabel: 'Sí',
            cancelLabel: 'No',
        },
        templates: { footer: undefined },
    };

    const modalResponse = this.userInteractiveService.openDialog(ModalGenericComponent, config);

    return await lastValueFrom(modalResponse.onClose);
  }
  
  private _storeData(record: any, btn: IAccionBoton, event: Event) {
    // Almacena data para leerla en componente destino
    const data = { ...record, CodfdCuerpo: 'TAREA' + record?.CodTareaCalculado };
    localStorage.setItem('navigationData', JSON.stringify(data));
  }
}